import script from "./BtnLote.vue?vue&type=script&setup=true&lang=js"
export * from "./BtnLote.vue?vue&type=script&setup=true&lang=js"

import "./BtnLote.vue?vue&type=style&index=0&id=23ca7ee9&lang=sass&scoped=true"

import exportComponent from "/var/www/html/resources/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ca7ee9"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
